import React, {useEffect, useState} from 'react'

import BasePage from "../../Components/BasePage/BasePage";

import './MenuPage.scss'
import {useNavigate, useSearchParams} from "react-router-dom";
import {ProductModel} from "../../Models/ProductModel";
import MenuItem from "../../Components/MenuItem/MenuItem";
import useHttpClient from "../../hooks/http/useHttpClient";
import Confirm from "../../Components/Confirm/Confirm";
import {setPanier, setSelectedPdv, setTimeCreationPanier} from "../../store/actions";
import {useDispatch, useSelector} from "react-redux";
import {StateModel} from "../../Models/StateModel";
import {OrderModel} from "../../Models/OrderModel";
import {useLoader} from "../../hooks/useLoader";
import Loader from "../../Components/Loader/Loader";
import {DoorModel} from "../../Models/DoorModel";
import Error from "../../Components/Error/Error";
import {useModal} from "../../hooks/useModal";
import {useError} from "../../hooks/useError";
import {useGetEvent} from "../../hooks/useGetEvent";
import {useGetStockAvailable} from "../../hooks/useGetStockAvailable";
import {useTranslation} from "react-i18next";

const MenuPage: React.FC = ({}) => {
    const {t} = useTranslation(['menu', 'common'])
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const {getProducts} = useHttpClient()
    const [searchParams,] = useSearchParams();
    const pdvId = searchParams.get("pdvId")

    const panier = useSelector<StateModel, OrderModel | undefined>(state => state.panier)
    const timeCreationPanier = useSelector<StateModel, number | undefined>(state => state.timeCreationPanier)

    const door = useSelector<StateModel, DoorModel | undefined>(state => state.door)

    const [products, setProducts] = useState<ProductModel[]>([])
    const [showConfirm, setShowConfirm] = useState<boolean>(false)
    const getStockAvailable = useGetStockAvailable()

    const loader = useLoader()
    const showError = useModal()
    const eventError = useError()
    const apiError = useError()
    const getEvent = useGetEvent(() => {
        loader.hide()
        eventError.open("")
    }, () => {
        loader.hide()
        apiError.open("")
    })

    useEffect(() => {
        if (timeCreationPanier) {
            const now = new Date().getTime();

            if (now - timeCreationPanier > 21600000) {
                dispatch(setPanier(undefined))
                dispatch(setTimeCreationPanier(undefined))
            }
        }
    }, [timeCreationPanier])


    useEffect(() => {
        if (pdvId) {
            dispatch(setSelectedPdv(+pdvId))
            loader.show()
            getEvent(
                searchParams.get("stadium") || undefined,
                () => {
                    void getProducts(pdvId).then((response: ProductModel[]) => {
                        setProducts(response.filter(p => getStockAvailable(p) > 0))
                        if (response.length === 0) {
                            showError.open()
                        }
                    }).catch(() => apiError.open(""))
                        .finally(loader.hide)
                }
            )
        }
    }, [pdvId])

    const onBackClick = () => {
        if (door) {
            if (panier?.orderProducts && panier.orderProducts.length > 0) {
                setShowConfirm(true)
            } else {
                back()
            }
        }
    }


    const back = () => {
        dispatch(setPanier(undefined))
        dispatch(setTimeCreationPanier(undefined))
        if (door) {
            navigate(`/stands?stadium=${searchParams.get("stadium")}&doorId=${door.id}`)
        } else {
            navigate(`/menu?stadium=${searchParams.get("stadium")}&pdvId=${pdvId}`)
        }
    }

    return (
        <BasePage showBack showHistorique showPanier onBack={onBackClick}>
            <div className="menuPageItems">
                {
                    products.map((p, i) => (
                        <MenuItem key={i} item={p}/>
                    ))
                }
            </div>
            <Confirm
                visible={showConfirm}
                title={t('menu:errors.abandonCartTitle')}
                subTitle={t('menu:errors.abandonCartSubtitle')}
                onCancel={() => setShowConfirm(false)}
                onOk={back}
            />
            <Error
                show={showError.visible}
                close={() => navigate(-1)}
                title={t('menu:errors.standUnavailableTitle')}
                subTitle={t('menu:errors.standUnavailableSubtitle')}
            />
            <Loader visible={loader.visible}/>
            <Error show={eventError.visible} title={t('common:errors.noEvent.title')}
                   subTitle={t('common:errors.noEvent.subtitle')}/>
            <Error show={apiError.visible} title={t('common:errors.serviceUnavailable.title')}
                   subTitle={t('common:errors.serviceUnavailable.subtitle')}/>
        </BasePage>
    )
}

export default MenuPage;
